import React from "react";

/**
 * Infinite marquee of "client" style badge cards. Because we don't have real
 * client logos and must not fabricate them, we render generic industry-sector
 * badges that scroll like a logo strip.
 */
const ITEMS = [
  "FinTech",
  "SaaS Products",
  "Data & Analytics",
  "Cloud & DevOps",
  "IT Services",
  "BPO & Support",
  "Manufacturing",
  "Healthcare",
  "E-commerce",
  "EdTech",
  "Logistics",
  "Consulting",
];

export default function ClientLogosMarquee() {
  return (
    <section className="py-12 md:py-16 bg-brand-soft border-y border-brand-border overflow-hidden">
      <div className="container-brand mb-6 md:mb-8 text-center">
        <span className="eyebrow">Industries We Recruit For</span>
        <h3 className="mt-2 font-heading font-bold text-brand-navy text-xl md:text-2xl">
          Trusted across sectors and functions
        </h3>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-brand-soft to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-brand-soft to-transparent z-10" />
        <div className="marquee-track flex gap-4 whitespace-nowrap will-change-transform">
          {[...ITEMS, ...ITEMS].map((item, idx) => (
            <div
              key={`${item}-${idx}`}
              className="shrink-0 px-6 py-3 rounded-lg bg-white border border-brand-border text-brand-navy font-heading font-semibold text-sm shadow-sm"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .marquee-track { animation: marquee 32s linear infinite; }
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>
    </section>
  );
}
